var _pattern, _pattern2, _pattern3, _g, _circle, _circle2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 233.21 72.63",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _pattern || (_pattern = /*#__PURE__*/React.createElement("pattern", {
    id: "a",
    height: 90.53,
    patternTransform: "translate(-1538.09 2155.25)",
    patternUnits: "userSpaceOnUse",
    viewBox: "0 0 90.53 90.53",
    width: 90.53
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h90.53v90.53h-90.53z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0h90.53v90.53h-90.53z",
    fill: "#2026d2"
  }))), _pattern2 || (_pattern2 = /*#__PURE__*/React.createElement("pattern", {
    id: "b",
    height: 90.53,
    patternTransform: "translate(-1538.09 2155.25)",
    patternUnits: "userSpaceOnUse",
    viewBox: "0 0 90.53 90.53",
    width: 90.53
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h90.53v90.53h-90.53z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0h90.53v90.53h-90.53z",
    fill: "#62e1fc"
  }))), _pattern3 || (_pattern3 = /*#__PURE__*/React.createElement("pattern", {
    id: "c",
    height: 90.53,
    patternTransform: "translate(-89.58 2115.25)",
    patternUnits: "userSpaceOnUse",
    viewBox: "0 0 90.53 90.53",
    width: 90.53
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h90.53v90.53h-90.53z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0h90.53v90.53h-90.53z",
    fill: "#62e1fc"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m52.52 22.45v48.82h-14.64v-4.59c-3.22 3.71-8 5.95-14.55 5.95-12.79 0-23.33-11.22-23.33-25.77s10.54-25.77 23.33-25.77c6.54 0 11.33 2.24 14.55 5.95v-4.59zm-14.64 24.41c0-7.32-4.88-11.86-11.62-11.86s-11.62 4.54-11.62 11.86 4.89 11.91 11.62 11.91 11.62-4.59 11.62-11.91z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m81.8 36.51v17.28c0 4.2 3.62 4.59 10.06 4.2v13.28c-19.13 2-24.7-3.81-24.7-17.48v-17.28h-7.81v-14.06h7.81v-9.27l14.64-4.39v13.66h10.06v14.06z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m100.15 0h14.65v71.27h-14.65z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m175.62 22.45v48.82h-14.62v-4.59c-3.22 3.71-8 5.95-14.54 5.95-12.79 0-23.34-11.22-23.34-25.77s10.55-25.77 23.34-25.77c6.54 0 11.32 2.24 14.54 5.95v-4.59zm-14.62 24.41c0-7.32-4.91-11.86-11.64-11.86s-11.62 4.59-11.62 11.91 4.88 11.91 11.62 11.91 11.64-4.64 11.64-11.96z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m233.21 41.3v30h-14.64v-27.86c0-6-3.81-8.88-8.5-8.88-5.37 0-9.08 3.12-9.08 10.06v26.65h-14.64v-48.82h14.65v4.55c2.64-3.61 7.52-5.95 14-5.95 9.81.04 18.21 7.07 18.21 20.25z"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 26.26,
    cy: 46.86,
    fill: "url(#b)",
    r: 6
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 149.36,
    cy: 46.86,
    fill: "url(#c)",
    r: 6
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.8b6f633f.svg";
export { ForwardRef as ReactComponent };